import React, { useState, useEffect } from 'react';
import { Factory, Package, Droplet, Globe } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import AnimatedCounter from './AnimatedCounter';

const StatsSection = () => {
  const [isStatsVisible, setIsStatsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsStatsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const statsSection = document.getElementById('stats-section');
    if (statsSection) {
      observer.observe(statsSection);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section id="stats-section" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 text-center">
          {[
            { id: 'stat-projects', end: 200, suffix: '+', label: 'Plant Installations', icon: Factory, color: 'alden-green' },
            { id: 'stat-bpm', end: 200, suffix: ' BPM', label: 'Max Filling Capacity', icon: Package, color: 'alden-green' },
            { id: 'stat-lph', end: 10000, suffix: ' LPH', label: 'Max RO Capacity', icon: Droplet, color: 'alden-green' },
            { id: 'stat-states', end: 15, suffix: '+ States', label: 'Pan India Presence', icon: Globe, color: 'alden-green' }
          ].map((stat) => (
            <Card key={stat.id} className="border-2 border-alden-green/20 hover:border-alden-green transition-all hover:shadow-xl">
              <CardContent className="p-8">
                <stat.icon className="w-16 h-16 text-alden-green mx-auto mb-4" />
                <div className="text-4xl font-bold text-alden-green mb-2">
                  {isStatsVisible ? <AnimatedCounter end={stat.end} suffix={stat.suffix} /> : `0${stat.suffix}`}
                </div>
                <div className="text-gray-600 font-semibold">{stat.label}</div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
